<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="relative mx-auto mb-16 flex max-w-3xl justify-center px-5 md:px-0">
    <div class="text-center">
      <h2 class="marker relative inline-block text-3xl font-bold md:text-[42px]">
        {{ t('title') }}
      </h2>
      <p class="text-2xl leading-10 md:text-[42px]">
        {{ t('subtitle') }}
      </p>
    </div>
    <div class="absolute right-8 top-full hidden md:-right-28 md:top-1/2 lg:block">
      <NuxtImg alt="" :src="`/img/pijl.svg`" width="150" />
    </div>
  </div>
</template>

<i18n lang="json">
{
  "nl": {
    "title": "De leukste bierfiets van het land!",
    "subtitle": "Boek op onze vaste locaties of een door jou gekozen locatie."
  },
  "en": {
    "title": "The best beer bike in the country!",
    "subtitle": "Book at our fixed locations or a location of your choice."
  },
  "fr": {
    "title": "Le meilleur vélo à bière du pays!",
    "subtitle": "Réservez dans nos lieux fixes ou un lieu de votre choix."
  }
}
</i18n>
